import { PlatformSlug } from 'constants/consts'
import { getPlatformProductConfig } from './platformConfig'

export type { PlatformProductConfig } from './platformConfig'
export { getPlatformProductConfig, isProductsAvailable } from './platformConfig'

export const MEMBERSHIPS_TAB = {
  id: 'memberships',
  title: 'Memberships',
  disabled: false,
}

export const EXTENSIONS_TAB = {
  id: 'extensions',
  title: 'Extensions',
  disabled: false,
}

export const ADDITIONAL_TAB = {
  id: 'additional-tests',
  title: 'Additional Tests',
  disabled: false,
}

export const PAUSE_TOKENS_TAB = {
  id: 'pause-tokens',
  title: 'Pause Tokens',
  disabled: false,
}

const TABS = [MEMBERSHIPS_TAB, EXTENSIONS_TAB, ADDITIONAL_TAB, PAUSE_TOKENS_TAB]

type Tab = typeof MEMBERSHIPS_TAB

const getHiddenTabs = (slug: PlatformSlug): Tab[] => {
  const config = getPlatformProductConfig(slug)
  const hiddenTabs: Tab[] = []

  if (!config || (!config.regularMemberships && !config.subscriptionMemberships)) {
    hiddenTabs.push(MEMBERSHIPS_TAB)
  }

  if (!config?.regularExtensions) {
    hiddenTabs.push(EXTENSIONS_TAB)
  }

  if (!config?.additionalTests) {
    hiddenTabs.push(ADDITIONAL_TAB)
  }

  if (!config?.pauseTokens) {
    hiddenTabs.push(PAUSE_TOKENS_TAB)
  }

  return hiddenTabs
}

export const getTabs = (platform: PlatformSlug) => TABS.filter((tab) => !getHiddenTabs(platform).includes(tab))

export const QUERY_PARAM = 'tab'
